module.exports = __webpack_public_path__ + "static/media/54_1155.6e2299fb.webp";